import './ModelMetricsPanel.scss';
import { ReactElement, ReactNode } from 'react';
import { formatNumber } from '@blisspointmedia/bpm-types/dist/formatUtils';
import { formatSpend } from '../forecasting-constants';
import { ScalingMetrics } from './scalingData';

interface ModelMetricsPanelProps {
  metrics: ScalingMetrics;
  extrapPoint: number;
  efficiencyMetric: string;
}

interface MetricRow {
  label: string;
  value: ReactNode;
}

export const ModelMetricsPanel = ({
  metrics,
  extrapPoint,
  efficiencyMetric
}: ModelMetricsPanelProps): ReactElement => {
  const { correlation, r2, mae, wmape, weekTotal, firstDay, lastDay } = metrics;
  const isRevenue = efficiencyMetric === 'ROAS';

  const rows: MetricRow[] = [
    { label: `Spend-${isRevenue ? 'Rev' : 'Vol'} Correlation`, value: correlation.toFixed(2) },
    { label: 'R²', value: r2.toFixed(2) },
    { label: 'wMAPE', value: `${wmape.toFixed(1)}%` },
    { label: 'MAE', value: formatNumber(mae, 0) },
    { label: 'Week total', value: weekTotal },
    { label: 'First day', value: firstDay },
    { label: 'Last day', value: lastDay },
    { label: 'Extrapolation start', value: formatSpend(extrapPoint) },
    { label: 'Efficiency metric', value: efficiencyMetric }
  ];

  return (
    <div className='model-metrics-panel'>
      <div className='model-metrics-title'>Model Metrics</div>
      <div className='model-metrics-rows'>
        {rows.map(row => (
          <div className='model-metrics-row' key={row.label}>
            <span className='model-metrics-label'>{row.label}</span>
            <span className='model-metrics-value'>{row.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
